import { render, staticRenderFns } from "./ProductForm.vue?vue&type=template&id=51f97fe9&scoped=true&"
import script from "./ProductForm.vue?vue&type=script&lang=js&"
export * from "./ProductForm.vue?vue&type=script&lang=js&"
import style0 from "./ProductForm.vue?vue&type=style&index=0&id=51f97fe9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f97fe9",
  null
  
)

export default component.exports
import {QForm,QScrollArea,QField,QRadio,QSelect,QCard,QExpansionItem,QInput,QCardSection,QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QForm,QScrollArea,QField,QRadio,QSelect,QCard,QExpansionItem,QInput,QCardSection,QIcon})
